import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import { useStore } from "vuex";
import { reactive, ref } from "vue";
import { ElLoading, ElMessage } from "element-plus";
import { getTimeText } from "@/assets/js/tool";
import { getReportListApi } from "@/api/reportApi.js";
import { useRoute } from "vue-router";
export default {
  name: "ReportList",
  setup() {
    let store = useStore();
    let route = useRoute();
    let reports = reactive({
      S0: {},
      S1: {},
      S2: {},
      S3: {},
      S4: {},
      S5: {},
      S9: {}
    });
    //时间选择器
    let datePicker = ref([]);
    if (new Date().getMonth() < 1) {
      datePicker.value[0] = new Date(new Date().getFullYear() - 1, 7, 1);
      datePicker.value[1] = new Date(new Date().getFullYear(), 1, 1);
    } else if (new Date().getMonth() < 7) {
      datePicker.value[0] = new Date(new Date().getFullYear(), 1, 1);
      datePicker.value[1] = new Date(new Date().getFullYear(), 7, 1);
    } else {
      datePicker.value[0] = new Date(new Date().getFullYear(), 7, 1);
      datePicker.value[1] = new Date(new Date().getFullYear() + 1, 1, 1);
    }
    function timestamp2Date(timestamp) {
      if (timestamp) {
        let date = new Date(parseInt(timestamp));
        let year = date.getFullYear();
        let month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
        let d = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
        return year + "年" + month + "月" + d + "日";
      } else {
        return "";
      }
    }
    //更新列表
    function getReportList() {
      const loading = ElLoading.service({
        lock: true,
        text: "加载中..",
        background: "rgba(0, 0, 0, 0.7)"
      });
      getReportListApi({
        begin: getTimeText(datePicker.value[0], true),
        end: getTimeText(datePicker.value[1], true)
      }).then(r => {
        loading.close();
        if (r.status < 400) {
          r.data.forEach(item => {
            Object.assign(reports[item.skill], item);
          });
          delete reports.S9;
        } else {
          ElMessage({
            type: "error",
            showClose: true,
            message: r.msg
          });
        }
        console.log(r);
        // reports;
      });
    }
    //选择时间
    getReportList();
    //获取交卷时间
    function getSubmitDate(userExam) {
      if (userExam.nextExam) {
        return getSubmitDate(userExam.nextExam);
      } else {
        return timestamp2Date(userExam.submitTime);
      }
    }
    function goReport(report, key) {
      let url = "";
      switch (key) {
        case "S0":
          {
            url = "/gz/reports/user-report-vspt.html?examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
        case "S1":
          {
            url = "/gz/reports/user-report-listen.html?skill=" + key + "&examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
        case "S2":
          {
            url = "/gz/reports/user-report-reading.html?skill=" + key + "&examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
        case "S3":
          {
            url = "/gz/reports/user-report-grammar.html?skill=" + key + "&examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
        case "S4":
          {
            url = "/gz/reports/user-report-writing.html?skill=" + key + "&examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
        case "S5":
          {
            url = "/gz/reports/user-report-oral.html?skill=" + key + "&examId=" + report.examId + "&userId=" + report.userId + "&appKey=" + route.query.appKey;
            break;
          }
      }
      let info = JSON.parse(window.localStorage.getItem("gz-userInfo"));
      if (info.identity == "试测校") {
        ElMessage({
          type: "warning",
          showClose: true,
          message: "无权限查看报告"
        });
        return;
      }
      if (url) window.open(url);
    }
    return {
      store,
      datePicker,
      reports,
      getReportList,
      getSubmitDate,
      goReport
    };
  }
};